import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	spinner: {
		marginLeft: 10,
		color: '#1A202C',
	},
}

const Spinner = withStyles(styles)((props: any) => (
	<>
		<CircularProgress className={props.classes.spinner} size={20} />
	</>
))
const LoadingButton = (props: any) => {
	const { children, loading = false, disabled, ...rest } = props

	return (
		<Button {...rest} disabled={loading || disabled}>
			{children}
			{loading && <Spinner {...rest} />}
		</Button>
	)
}

export default LoadingButton
